/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, createElem, getBooleanTypeAttr, getNumTypeAttr, removeAttrs, setCss } from '../../dom-utils';
import { type } from '../../utils';
import PREFIX from '../prefix';
function getScroll(target, top) {
    var prop = top ? 'pageYOffset' : 'pageXOffset';
    var method = top ? 'scrollTop' : 'scrollLeft';
    var ret = target[prop];
    if (typeof ret !== 'number') {
        ret = window.document.documentElement[method];
    }
    return ret;
}
function getOffset(element) {
    var rect = element.getBoundingClientRect();
    var scrollTop = getScroll(window, true);
    var scrollLeft = getScroll(window);
    var docEl = window.document.body;
    var clientTop = docEl.clientTop || 0;
    var clientLeft = docEl.clientLeft || 0;
    return {
        top: rect.top + scrollTop - clientTop,
        left: rect.left + scrollLeft - clientLeft
    };
}
var Affix = /** @class */ (function () {
    function Affix() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-affix', { all: true });
        this._create(this.COMPONENTS);
    }
    Affix.prototype.config = function (el) {
        var target = $el(el);
        var _a = Affix.prototype._attrs(target), offsetTop = _a.offsetTop, offsetBottom = _a.offsetBottom;
        var elOffset = getOffset(target);
        var elHeight = target.offsetHeight;
        var windowHeight = window.innerHeight;
        var affixed = false, offsetType = 'top';
        if (offsetBottom >= 0) {
            offsetType = 'bottom';
        }
        return {
            events: function (_a) {
                var onChange = _a.onChange;
                var handler = function () {
                    var isAffix = target.classList.contains("" + PREFIX.affix);
                    var scrollTop = getScroll(window, true);
                    // 固定到顶部时触发事件
                    if (elOffset.top - offsetTop < scrollTop && offsetType == 'top' && !isAffix) {
                        affixed = true;
                        onChange && type.isFn(onChange, affixed);
                    }
                    else if (elOffset.top - offsetTop > scrollTop &&
                        offsetType == 'top' &&
                        affixed) {
                        affixed = false;
                        onChange && type.isFn(onChange, affixed);
                    }
                    // 固定到底部时触发事件
                    if (elOffset.top + offsetBottom + elHeight > scrollTop + windowHeight &&
                        offsetType == 'bottom' &&
                        !affixed) {
                        affixed = true;
                        onChange && type.isFn(onChange, affixed);
                    }
                    else if (elOffset.top + offsetBottom + elHeight < scrollTop + windowHeight &&
                        offsetType == 'bottom' &&
                        affixed) {
                        affixed = false;
                        onChange && type.isFn(onChange, affixed);
                    }
                };
                handler();
                // 这里 useCapture 选项设置为 true 解决了被下面同样的滚动监听覆盖的 bug
                // 相当于提高了事件触发优先级
                window.addEventListener('scroll', handler, true);
                window.addEventListener('resize', handler, true);
            }
        };
    };
    Affix.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), offsetTop = _a.offsetTop, offsetBottom = _a.offsetBottom, useCapture = _a.useCapture;
            var wrapper = createElem('div');
            var cloneElm = _this._createCloneElm(wrapper);
            node.after(wrapper);
            wrapper.appendChild(node);
            _this._handleScroll(node, cloneElm, offsetTop, offsetBottom, useCapture);
            removeAttrs(node, ['offset-top', 'offset-bottom', 'use-capture']);
        });
    };
    Affix.prototype._createCloneElm = function (node) {
        var element = createElem('div');
        setCss(element, 'display', 'none');
        node.after(element);
        return element;
    };
    Affix.prototype._handleScroll = function (node, cloneElm, offsetTop, offsetBottom, useCapture) {
        var container = node.parentElement;
        var elOffset = getOffset(node);
        var elHeight = node.offsetHeight;
        var windowHeight = window.innerHeight;
        var affix = false, top, left, width, bottom, offsetType = 'top', cloneElmWidth, cloneElmHeight, display;
        if (offsetBottom >= 0) {
            offsetType = 'bottom';
        }
        var scroll = function () {
            var isAffix = node.classList.contains("" + PREFIX.affix);
            var scrollTop = getScroll(window, true);
            // 固定到顶部
            if (elOffset.top - offsetTop < scrollTop && offsetType == 'top' && !isAffix) {
                affix = true;
                display = '';
                top = offsetTop + "px";
                left = elOffset.left + "px";
                width = container.offsetWidth + "px";
                cloneElmWidth = node.clientWidth + "px";
                cloneElmHeight = node.clientHeight + "px";
                node.classList.add("" + PREFIX.affix);
            }
            else if (elOffset.top - offsetTop > scrollTop && offsetType == 'top' && affix) {
                top = '';
                left = '';
                width = '';
                affix = false;
                display = 'none';
                cloneElmWidth = '';
                cloneElmHeight = '';
                node.classList.remove("" + PREFIX.affix);
            }
            // 固定到底部
            if (elOffset.top + offsetBottom + elHeight > scrollTop + windowHeight &&
                offsetType == 'bottom' &&
                !affix) {
                affix = true;
                left = elOffset.left + "px";
                width = container.offsetWidth + "px";
                bottom = offsetBottom + "px";
                node.classList.add("" + PREFIX.affix);
            }
            else if (elOffset.top + offsetBottom + elHeight < scrollTop + windowHeight &&
                offsetType == 'bottom' &&
                affix) {
                affix = false;
                left = '';
                width = '';
                bottom = '';
                node.classList.remove("" + PREFIX.affix);
            }
            setCss(node, 'top', top);
            setCss(node, 'left', left);
            setCss(node, 'width', width);
            setCss(node, 'bottom', bottom);
            setCss(cloneElm, 'width', cloneElmWidth);
            setCss(cloneElm, 'height', cloneElmHeight);
            setCss(cloneElm, 'display', display);
        };
        scroll();
        window.addEventListener('scroll', scroll, useCapture);
        window.addEventListener('resize', scroll, useCapture);
    };
    Affix.prototype._attrs = function (node) {
        return {
            offsetTop: getNumTypeAttr(node, 'offset-top', 0),
            offsetBottom: getNumTypeAttr(node, 'offset-bottom'),
            useCapture: getBooleanTypeAttr(node, 'use-capture')
        };
    };
    return Affix;
}());
export default Affix;
